export const filterOptions = [
  { value: "hbl", label: "HBL" },
  { value: "mbl", label: "MBL" },
  { value: "origen", label: "Origen" },
  { value: "destino", label: "Destino" },
  { value: "mrn", label: "MRN" },
  { value: "embarcador", label: "Embarcador" },
  { value: "contenedores", label: "Contenedores" },
  { value: "eta", label: "ETA" },
];
